import axios from "axios";
import { ToastProgrammatic as Toast } from "buefy";
import router from "@/router";

const removeToken = () => {
  delete axios.defaults.headers.common.Authorization;
  localStorage.removeItem("token");
  axios.token = null;
  // this.$store.commit("user/resetState");
};

const expiredToken = () => {
  const currentPath = router.currentRoute.path;

  setTimeout(() => {
    Toast.open({
      message: "Tu sesión ha expirado debido a inactividad",
      position: "is-top-right",
      type: "is-warning"
    });
  }, 2000);
  removeToken();
  if (currentPath.includes("/admin")) {
    router.push({ name: "admin-login" });
  }
};

const interceptResErrors = err => {
  console.log("err", err, err?.response?.status, axios?.num_errors);
  if (err.response.status === 401) {
    if (
      err.response.data.error.code == "USER_DISABLED" ||
      err.response.data.error.code == "EMAIL_NOT_VERIFIED" ||
      err.response.data.error.code === "LOGIN_FAILED"
    ) {
      return Promise.reject(err);
    }

    expiredToken();
  }
  return Promise.reject(err);
};

const interceptResponse = res => res;

axios.interceptors.response.use(interceptResponse, interceptResErrors);

export default {
  addTokenFromLocalStorage() {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      axios.token = token;
      axios.defaults.headers.common.Authorization = token.id;
    }
  },

  setToken(token) {
    axios.token = token;
    axios.defaults.headers.common.Authorization = token.id;
    localStorage.setItem("token", JSON.stringify(token));
  },

  removeToken,

  getUserInformation() {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      return token;
    }
    return null;
  }
};
